export const PAYMENT_METHODS_LOAD = '@ANALYTICS/PAYMENT_OPTIONS_LOAD'
export const FINANCE_CALC_LOAD = '@ANALYTICS/FINANCE_CALC_LOAD'
